import "./AdProfile.scss"
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { useState } from "react";
import { useSelector } from "react-redux";
import { FaSave } from "react-icons/fa";
import app from "../../../utils/firebase";
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    LinearProgress
} from "@mui/material";
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
} from "firebase/storage";
import Select from "react-select";
import newRequest from "../../../utils/newRequest";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { useDispatch } from 'react-redux';
import { setAvator } from "../../../redux/userSlice";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { MdAdd, MdClose, MdDelete } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { showToast } from "../../../toastService";


const AdProfile = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser, currentUserAvator } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);

    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [img, setImg] = useState(null);
    const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const [allRoleMenus, setAllRoleMenus] = useState([]);
    const [selectedRoleMenu, setSelectedRoleMenu] = useState(null);

    const [favMenus, setFavMenus] = useState([]);
    const [selectedFavMenu, setSelectedFavMenu] = useState(null);

    const [documentEnabled, setDocumentEnabled] = useState("N");

    const [userData, setUserData] = useState(null);
    const [selectedSettingMenu, setSelectedSettingMenu] = useState(null);
    const [selectedSettingsMenu, setSelectedSettingsMenu] = useState(null);
    const [settingMenus, setSettingMenus] = useState([]);

    const handleSetUserData = (name, value) => {
        setUserData((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const fetchUser = async () => {
        try {
            const res = await newRequest.get("/adUser/loggedUser");
            setUserData(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchSettingsMenu = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Profile Menus" });
            setSettingMenus(res.data);
            setSelectedSettingMenu(res.data[0]);
        } catch (err) {
            console.log(err);
        }
    };



    const fetchRoleMenus = async (userDocid) => {
        try {
            const res = await newRequest.get(`/adUserRole/userRoles/${userDocid}`);
            const options = res.data?.unique_group_menus?.map((mn) => ({
                role_code: mn?.role_code,
                role_name: mn?.role_name,
                menu_group_name: mn?.menu_group_name,
                menu_name: mn?.menu_name,
                menu_function: mn?.menu_function,
                value: mn?._id,
                label: `Role : ${mn?.role_name} - Menu : ${mn?.menu_name}`
            }));
            setAllRoleMenus(options);
        } catch (err) {
            console.log(err);
        }
    };



    const handleUploadDoalogClose = () => {
        setIsUploadDialogOpen(false);
    };

    const uploadToFirebase = async (file, fileFolder) => {
        setIsUploadDialogOpen(true);
        const storage = getStorage(app);
        const fileName = new Date().getTime() + file.name;
        const fileExtension = file.name.split(".").pop(); // Get file extension
        const fileType = file.type; // Get file type
        const fileSizeKB = file.size / 1024; // Get file size in KB
        const storageRef = ref(
            storage,
            `qc_${currentUser.usr_org_code}/${fileFolder}/${fileName}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress(Math.round(progress));
                switch (snapshot.state) {
                    case "paused":
                        console.log("Upload is paused");
                        break;
                    case "running":
                        console.log("Upload is running");
                        break;
                    default:
                        break;
                }
            },
            (error) => {
                setIsUploadDialogOpen(false);
                console.log(error);
            },
            async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                if (fileFolder === "profiles") {
                    // update user profile image
                    const res = await newRequest.post("/adUser/upd", { user_docid: currentUser.usr_id, usr_photo_url: downloadURL });
                    // setUsrPhotoUrl(downloadURL)
                    setImg("");
                    setIsUploadDialogOpen(false);
                    dispatch(setAvator(downloadURL));
                } else {
                    await saveFileToDb(
                        file.name,
                        fileName,
                        fileExtension,
                        downloadURL,
                        "kyc",
                        fileSizeKB,
                        currentUser.usr_id,
                    );
                    // setImg("");
                    setIsUploadDialogOpen(false);
                }
            }
        );
    };

    const saveFileToDb = async (
        fl_name,
        fl_internal_name,
        fl_type,
        fl_path,
        fl_category,
        fl_size_kb,
        fl_parent_doc_id
    ) => {
        try {
            const params = {
                fl_name: fl_name,
                fl_internal_name: fl_internal_name,
                fl_type: fl_type,
                fl_path: fl_path,
                fl_category: fl_category,
                fl_doc_type: "",
                fl_doc_no: "",
                fl_doc_index: "",
                fl_doc_sub_index: "",
                fl_ent_code: "",
                fl_aent_code: "",
                fl_user_id: currentUser.usr_id,
                fl_size_kb,
                fl_parent_doc_id,
            };

            const res = await newRequest.post("/files/add", params);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const saveRecord = async () => {
        try {
            if (img) {
                await uploadToFirebase(img, "profiles");
            }
        } catch (error) {
            console.log(error)
        }
    }
    const fetchFavouriteMenus = async () => {
        try {
            const res = await newRequest.get("/adUserRole/fav");
            // console.log(`User FavouriteMenus ${JSON.stringify(res.data, null, 2)}`);
            setFavMenus(res.data);
        } catch (err) {
            console.log(err);
        }
    };


    const handleCancel = () => {
        setIsConfirmDialogOpen(false);
    };

    useEffect(() => {
        fetchUser();
        fetchFavouriteMenus();
        fetchSettingsMenu();
        fetchRoleMenus(currentUser?._id);
    }, [currentUser]);

    return (
        <motion.div className="ad-profile"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            <div className="ad-profile-main-wrapper">
                <div className="profile-navbar">
                    <div className="left">
                        <h1 className="main-title">{`${currentUser.usr_full_name} ${t('profile').toUpperCase()}`}</h1>
                    </div>
                    <div className="right">
                        <CustomLoadingButton
                            currentTheme={currentTheme}
                            iconPosition="end"
                            borderRadiusType="both"
                            variant="tint"
                            color="#00D37F"
                            tooltip="Save changes"
                            endIcon={<FaSave />}
                            onClick={saveRecord}
                        >
                            {t('save').toUpperCase()}
                        </CustomLoadingButton>
                    </div>
                </div>
                <div className="profile-content">
                    <div className="profile-content-wrapper">
                        <div className="content-form">
                            <div className="input-item-with-label">
                                <label htmlFor="usr_full_name"
                                    className="form-input-label"
                                    style={{ width: "100px" }}>
                                    {t('name').toUpperCase()}
                                </label>
                                <input
                                    name="usr_full_name"
                                    type="text"
                                    placeholder={t('name').toUpperCase()}
                                    className="form-input-item"
                                    style={{ width: "100%" }}
                                    value={userData?.usr_full_name || ""}
                                    onChange={(e) => handleSetUserData("usr_full_name", e.target.value)}
                                    disabled={documentEnabled === "N"}
                                />
                            </div>
                            <div className="content-form-wrapper">
                                <div className="content-form-left">
                                    <div className="input-item-with-label">
                                        <label htmlFor="usr_un"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('username').toUpperCase()}
                                        </label>
                                        <input
                                            name="usr_un"
                                            type="text"
                                            placeholder={t('username').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.usr_un || ""}
                                            onChange={(e) => handleSetUserData("usr_un", e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label htmlFor="usr_email"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('email').toUpperCase()}
                                        </label>
                                        <input
                                            name="usr_email"
                                            type="email"
                                            placeholder={t('email').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.usr_email || ""}
                                            onChange={(e) => handleSetUserData("usr_email", e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label htmlFor="usr_phone_no"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('phoneNo').toUpperCase()}
                                        </label>
                                        <input
                                            name="usr_phone_no"
                                            type="text"
                                            placeholder={t('phoneNo').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.usr_phone_no || ""}
                                            onChange={(e) => handleSetUserData("usr_phone_no", e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                </div>
                                <div className="content-form-right">
                                    <div className="input-item-with-label">
                                        <label htmlFor="profile_name_xx"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('profile').toUpperCase()}
                                        </label>
                                        <input
                                            name="profile_name_xx"
                                            type="text"
                                            placeholder={t('profile').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.profile_name_xx || ""}
                                            onChange={(e) => handleSetUserData("profile_name_xx", e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label htmlFor="bizunit_name_xx"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('bizUnit').toUpperCase()}
                                        </label>
                                        <input
                                            name="bizunit_name_xx"
                                            type="text"
                                            placeholder={t('bizUnit').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.bizunit_name_xx || ""}
                                            onChange={(e) => handleSetUserData("bizunit_name_xx", e.target.value)}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                    <div className="input-item-with-label">
                                        <label htmlFor="user_type_xx"
                                            className="form-input-label"
                                            style={{ width: "120px" }}>
                                            {t('type').toUpperCase()}
                                        </label>
                                        <input
                                            name="user_type_xx"
                                            type="text"
                                            placeholder={t('type').toUpperCase()}
                                            className="form-input-item"
                                            style={{ width: "100%" }}
                                            value={userData?.user_type_xx || ""}
                                            onChange={(e) => {
                                                try {
                                                    handleSetUserData("user_type_xx", e.target.value);
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                            disabled={documentEnabled === "N"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-logo">
                            <div className="logo">
                                {!img && (
                                    <img
                                        src={currentUser?.usr_photo_url || "/img/noavatar.jpg"}
                                        alt=""
                                        className="img"
                                    />
                                )}
                                {img && (
                                    <img
                                        src={
                                            img ? URL.createObjectURL(img) : "/img/noavatar.jpg"
                                        }
                                        alt=""
                                        className="img"
                                    />
                                )}
                                <input
                                    type="file"
                                    id="file"
                                    style={{ display: "none" }}
                                    accept="image/*"
                                    onChange={(e) => setImg(e.target.files[0])}
                                />
                                <label htmlFor="file" style={{ margin: "10px 0px", cursor: "pointer" }}>
                                    <div className="item">
                                        <span className="sub-title">{t('changeAvatar')}</span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <hr className="separator-h" />
                    <span className="sub-title">{selectedSettingMenu?.sys_code?.toUpperCase()} {t('settings').toUpperCase()} </span>
                    <div className="profile-settings-wrapper">
                        <div className="settings-summary-wrapper">
                            <div className="settings-wrapper">
                                {selectedSettingMenu?.sys_code === "Quick Access" &&
                                    <div className="quick-Access-wrapper">
                                        <div className="table-content">
                                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                <Table sx={{ width: "max-content", border: 'none' }}>
                                                    <TableHead className="tablehead">
                                                        <TableRow className="tablerow">
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                #
                                                            </TableCell>
                                                            {/* <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                                                <span />
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                                                <span />
                                                            </TableCell> */}
                                                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "10px", backgroundColor: "transparent" }}>
                                                                    <div className="input-item-with-label" style={{ flex: "1.3", gap: "5px" }}>
                                                                        <Select
                                                                            id="sys_menus"
                                                                            name="sys_menus"
                                                                            menuPortalTarget={document.body}
                                                                            styles={{
                                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                menuPortal: base => ({
                                                                                    ...base,
                                                                                    zIndex: 9999,
                                                                                })
                                                                            }}
                                                                            width="100%"
                                                                            height="40px"
                                                                            value={selectedRoleMenu}
                                                                            onChange={(selectedOption) => setSelectedRoleMenu(selectedOption)}
                                                                            options={allRoleMenus}
                                                                            isClearable={true}
                                                                            isSearchable={true}
                                                                            placeholder={t('menu').toUpperCase()}
                                                                        />
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    if (!selectedRoleMenu?.value) {
                                                                                        setNotifyDialogTitle("Note!");
                                                                                        setNotifyDialogText(`Please select menu!`);
                                                                                        setIsNotifyDialogOpen(true);
                                                                                        return;
                                                                                    }
                                                                                    const res = await newRequest.post("/adUser/addFavMenu",
                                                                                        {
                                                                                            menu_docid: selectedRoleMenu?.value
                                                                                        });
                                                                                    if (res.data?.msg === "added") {
                                                                                        setFavMenus((prev) => [...prev,
                                                                                        {
                                                                                            role_code: selectedRoleMenu?.role_code,
                                                                                            role_name: selectedRoleMenu?.role_name,
                                                                                            menu_group_name: selectedRoleMenu?.menu_group_name,
                                                                                            menu_name: selectedRoleMenu?.menu_name,
                                                                                            menu_function: selectedRoleMenu?.menu_function,
                                                                                            _id: selectedRoleMenu?.value
                                                                                        }]);
                                                                                        setSelectedRoleMenu(null);
                                                                                        showToast("Added!", "success");
                                                                                    } else if (res.data?.msg === "exists") {
                                                                                        showToast(`${selectedRoleMenu?.label} is already a shortcut`, "warning");
                                                                                    } else {
                                                                                        showToast("Error adding shortcut!", "error");
                                                                                    }
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }}
                                                                            color="#388E3C"
                                                                            icon={<MdAdd />}
                                                                            width={"30px"}
                                                                            height={"30px"} />
                                                                    </div>

                                                                    <div className="search-input-wrapper" style={{ flex: "1" }}>
                                                                        <FiSearch className="search-input-icon" />
                                                                        <input
                                                                            className="search-input"
                                                                            type="text"
                                                                            placeholder={`${t('search')}`}
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                                        />
                                                                        {searchTerm?.length > 0 && (
                                                                            <MdClose
                                                                                onClick={async (e) => {
                                                                                    try {
                                                                                        setSearchTerm("");
                                                                                        await fetchFavouriteMenus();
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }}
                                                                                className="search-input-icon"
                                                                            />
                                                                        )}
                                                                        {searchTerm?.length === 0 && (
                                                                            <span className="search-input-icon" />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </TableCell>
                                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                <span>{t('action')}</span>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="tablebody">
                                                        {favMenus?.map((row, index) => (
                                                            <TableRow
                                                                key={row._id}
                                                                className={`${selectedFavMenu?._id === row._id ? "tablerow current" : "tablerow"}`}
                                                                onClick={() => setSelectedFavMenu(row)}
                                                            >
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                                                    <span className="sub-title">{row?.role_name} </span>
                                                                    <span className="sub-title xrsmall soft">{row?.role_code} </span>
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ maxWidth: "120px" }}>
                                                                    <span className="sub-title">{row?.menu_group_name} </span>
                                                                    <span className="sub-title xrsmall soft">{row?.menu_group_name} </span>
                                                                </TableCell>
                                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                                    <span className="sub-title nowrap">{row?.menu_name} </span>
                                                                    <span className="sub-title xrsmall soft">{row?.menu_function} </span>
                                                                </TableCell>
                                                                <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                    <CircularButton
                                                                        currentTheme={currentTheme}
                                                                        color="#E53935"
                                                                        tooltip={`Remove ${row?.menu_name}`}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const res = await newRequest.get(`/adUser/removeFavMenu/${row._id}`);
                                                                                if (res.data?.msg === "removed") {
                                                                                    setFavMenus((prev) => prev.filter(menu => menu?._id !== row._id));
                                                                                    showToast("Removed!", "success");
                                                                                } else {
                                                                                    showToast("Error removing!", "error");
                                                                                }
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                        icon={<MdDelete />}
                                                                        width={"30px"}
                                                                        height={"30px"} />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>}
                                {selectedSettingMenu?.sys_code === "Access Logs" &&
                                    <motion.div className="access-logs-wrapper"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <span>{t('logs')}</span>
                                    </motion.div>}
                                {selectedSettingMenu?.sys_code === "Limits" &&
                                    <motion.div
                                        className="limits-wrapper"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <span>{t('limits')}</span>
                                    </motion.div>}
                                {selectedSettingMenu?.sys_code === "Devices" &&
                                    <motion.div
                                        className="devices-wrapper"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1, transition: { duration: 1 } }}
                                        exit={{ opacity: 0, transition: { duration: 1 } }}>
                                        <span>{t('devices')}</span>
                                    </motion.div>}
                            </div>
                            <div className="settings-options">
                                <div className="options-list">
                                    {settingMenus?.map((row) => (
                                        <span
                                            key={row._id}
                                            className={`${selectedSettingMenu?._id === row._id
                                                ? "single-option active"
                                                : "single-option"
                                                }`}
                                            onClick={async () => {
                                                try {
                                                    setSelectedSettingMenu(row);
                                                } catch (error) {
                                                    console.log(error);
                                                }
                                            }}
                                        >
                                            <h1 className="sub-title">{row?.sys_name}</h1>
                                            <h1 className="sub-title soft">{row?.sys_desc}</h1>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* progress dialog for file upload  */}
            <UploadDialog
                open={isUploadDialogOpen}
                handleClose={handleUploadDoalogClose}
                uploadProgress={uploadProgress}
            />
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>{t("close")}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={() => setIsConfirmDialogOpen(false)}
                dialogTitle={t("confirmation")}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>
            )}
        </motion.div>
    )
}


const UploadDialog = ({ open, handleClose, uploadProgress }) => {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Progress</DialogTitle>
            <DialogContent>
                <LinearProgress variant="determinate" value={uploadProgress} />
                {uploadProgress && <p>{uploadProgress}% Complete</p>}
            </DialogContent>
        </Dialog>
    );
};

export default AdProfile